<!-- Invalid handler for event “click“: got undefined  @click="formData.xxx" 是 formData.xxx 报的错-->
<!-- 开通发票 -->
<template>
  <div v-loading="loading">
    <div v-if="!isCompanyWhetherSystemIntegration" class="invoive-serve">
      <!-- <eSteps :stepList="stepList" :isActive="isActive"></eSteps> -->
      <!-- <eui-steps
        :active="isActive"
        style="margin-bottom: 40px; margin-top: 25px"
      >
        <eui-step title="填写信息"></eui-step>
        <eui-step title="开通审核"></eui-step>
        <eui-step
          :title="formData.platformStatus === 1 ? '开通成功' : '开通失败'"
        ></eui-step>
      </eui-steps> -->
      <div style="display: flex; justify-content: center">
        <eProcess :process-data="processData" :is-active="isActive"></eProcess>
      </div>

      <div v-if="isActive === 1">
        <div class="explain">
          易派客平台与百望云合作推出电子发票线上开具功能，企业在当前页面提交信息并开通成功后，可将开票信息一键推送至百望平台，在百望平台集中进行开票管理
        </div>
        <!-- 信息填写 -->
        <div class="commodity-list">
          <div class="invoice-form">
            <el-form
              ref="formDom"
              :rules="formDataRules"
              :model="formData"
              class="form-content"
              size="small"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    :label-width="labelWidth"
                    label="供应商名称："
                    prop="companyName"
                  >
                    <div>{{ companyInfo.companyName }}</div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label-width="labelWidth"
                    label="税号："
                    prop="taxId"
                  >
                    <el-input
                      v-model="formData.taxId"
                      name="enquiryMobile"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    :label-width="labelWidth"
                    label="邮箱："
                    prop="email"
                  >
                    <el-input
                      v-model="formData.email"
                      name="enquiryRealName"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label-width="142px"
                    label="纳税省份："
                    prop="province"
                  >
                    <el-select
                      v-model="formData.province"
                      placeholder="请选择税省份"
                    >
                      <el-option
                        v-for="(item, index) in provinceOptions"
                        :key="index"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    :label-width="labelWidth"
                    label="公司电话："
                    prop="telephone"
                  >
                    <el-input
                      v-model="formData.telephone"
                      name="telephone"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label-width="labelWidth"
                    label="公司地址："
                    prop="address"
                  >
                    <el-input
                      v-model="formData.address"
                      name="address"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label-width="142px"
                    label="纳税资质："
                    prop="taxpayerQualification"
                  >
                    <el-select
                      v-model="formData.taxpayerQualification"
                      placeholder="请选择纳税资质"
                    >
                      <el-option
                        v-for="(item, index) in taxpayerQualificationOptions"
                        :key="index"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label-width="labelWidth"
                    label="银行名称："
                    prop="bank"
                  >
                    <el-input v-model="formData.bank" name="bank"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    :label-width="labelWidth"
                    label="银行账号："
                    prop="bankAccounts"
                  >
                    <el-input
                      v-model="formData.bankAccounts"
                      name="bankAccounts"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <div class="agreement">
          <span class="check-box">
            <el-checkbox v-model="confirmAgreement"></el-checkbox>
          </span>
          <span>我已阅读并确认</span>
          <span class="show-agreement" @click="showAgreement()"
            >《电子发票服务开通规则》</span
          >
        </div>
        <div class="button">
          <eui-btn v-debounce="() => submitInfo()" class="btn submit-btn">
            提交
          </eui-btn>
        </div>
      </div>

      <div v-if="isActive === 2">
        <div class="explain">
          易派客平台与百望云合作推出电子发票线上开具功能，企业在当前页面提交信息并开通成功后，可将开票信息一键推送至百望平台，在百望平台集中进行开票管理。
        </div>
        <div class="waring">
          <img
            class="waring-icon"
            src="../../../../../assets/img/product/doubt.png"
            alt=""
          />
          <span>你的开通申请已提交，预计在1个工作日内完成审核</span>
        </div>
      </div>

      <div v-if="isActive === 3">
        <div class="explain">
          易派客平台与百望云合作推出电子发票线上开具功能，企业在当前页面提交信息并开通成功后，可将开票信息一键推送至百望平台，在百望平台集中进行开票管理。
        </div>
      </div>
    </div>
    <div v-else class="invoive-serve">
      <div class="explain" style="text-align: center">
        电子发票服务正在内测中，敬请期待
      </div>
    </div>

    <div v-if="isActive === 3" class="invoive-serve">
      <div v-if="formData.platformStatus === 1" class="invoive-serve-success">
        <div class="text">
          你的电子发票服务已开通,服务有效期至：{{
            formatPlatformExpireTime(formData.platformExpireTime)
          }}
        </div>
        <div class="config-text">
          <span>如需关闭，请点击：</span>
          <span class="text-btn" @click="goConfig">关闭电子发票服务</span>
        </div>
        <div class="invoice-manerge">
          <eui-btn type="primary" @click="goManner">开票管理</eui-btn>
        </div>
      </div>
      <div v-if="formData.platformStatus === 2">
        <div class="warn">
          <img
            class="warn-icon"
            src="../../../../../assets/img/product/doubt.png"
            alt=""
          />
          <div class="warn-text">
            <div>你的电子发票服务开通审核未通过，原因如下</div>
            <div>审核未通过原因：{{ formData.platformRefuseReason }}</div>
          </div>
        </div>
        <div class="reset-button">
          <eui-btn type="primary" @click="resetInfo()">重新申请</eui-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import invoiceApi from '@/modules/projectA/api/electronicInvoice';
import { debounce } from '@/modules/projectA/utils/throttle.js';
import utils from '@/modules/projectA/utils/utils';
import { isEmailAvailable } from '../../../utils/validate';
import eProcess from '../../../components/common/e-process.vue';

export default {
  components: {
    eProcess,
  },
  data() {
    return {
      loading: true,
      processData: [
        { itemName: '填写信息' },
        { itemName: '开通审核' },
        { itemName: '开通成功' },
      ],
      isActive: 1,
      applyResult: true,
      labelWidth: '142px',
      formData: {},
      formDataRules: {
        companyName: {
          type: 'string',
          required: true,
        },
        taxId: [
          {
            type: 'string',
            required: true,
            message: '请输入税号',
            trigger: 'blur',
          },

          { min: 1, max: 50, message: '长度需小于50字符', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请填邮箱', trigger: 'blur' },
          { validator: isEmailAvailable, trigger: 'blur' },
          { min: 1, max: 50, message: '长度需小于50字符', trigger: 'blur' },
        ],
        province: [
          { required: true, message: '请选择纳税省份', trigger: 'change' },
        ],
        bank: [
          { min: 1, max: 255, message: '长度需小于255字符', trigger: 'blur' },
        ],
        bankAccounts: [
          {
            min: 1,
            message: '银行账号输入不正确',
            trigger: 'blur',
          },
          {
            max: 32,
            message: '银行账号输入不正确',
            trigger: 'blur',
          },
        ],
        telephone: [
          { min: 1, max: 50, message: '长度需小于50字符', trigger: 'blur' },
        ],
        address: [
          { min: 1, max: 255, message: '长度需小于255字符', trigger: 'blur' },
        ],
      },
      companyInfo: {},
      confirmAgreement: true,
      taxpayerQualificationOptions: ['一般纳税人', '小规模纳税人'],
      provinceOptions: [],
      isCompanyWhetherSystemIntegration: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  watch: {},
  mounted() {
    this.companyWhetherSystemIntegration();
    this.getInvoiceInfo();
    this.getTaxProvinces();
  },
  created() {},
  beforeDestroy() {},
  methods: {
    formatPlatformExpireTime(time) {
      const date = new Date(time);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}年${month}月${day}日`;
    },
    // 获得企业信息
    async getInvoiceInfo() {
      const params = {
        companyId: this.userInfo.companyId,
      };
      const info = await invoiceApi.invoiceInfo(params);
      if (info.success) {
        this.companyInfo = info.data;
        this.getFormInfo(info.data);
      } else {
        this.$message.error('企业信息获取失败');
      }
    },
    // 获得表单信息
    getFormInfo(data) {
      this.formData = data;
      if (['0'].indexOf(data.platformStatus.toString()) !== -1) {
        this.isActive = 2;
      }
      if (['10'].indexOf(data.platformStatus.toString()) !== -1) {
        this.isActive = 1;
      }
      if (['1', '2', '3', '4'].indexOf(data.platformStatus.toString()) !== -1) {
        this.isActive = 3;
      }

      this.loading = false;
    },
    // 提交
    submitInfo() {
      debounce(() => {
        this.$refs.formDom.validate(async (valid) => {
          if (valid) {
            if (!this.confirmAgreement) {
              this.$message.warning('请阅读并确认《电子发票服务开通协议》');
              return false;
            }
            const query = this.formData;
            query.confirmAgreement = 1;
            delete query.platformStatus;
            console.log(query);
            this.loading = true;
            const info = await invoiceApi.submitBaiWangInvoice(query);
            if (info.success) {
              this.$message.success('提交成功');
              this.getInvoiceInfo();
              this.getTaxProvinces();
            }

            this.loading = false;
          }
          return true;
        });
      }, 500);
    },
    // 获得纳税省份
    async getTaxProvinces() {
      const info = await invoiceApi.getTaxProvinces();
      if (info.success) {
        this.provinceOptions = info.data;
      }
    },
    // 关闭电子发票服务
    goConfig() {
      this.$router.push({ path: '/transactionModeManage' });
    },
    // 管理发票
    goManner() {
      this.$router.push({ path: '/transactionModeManage' });
      this.$router.push({
        path: '/invocieManage',
      });
    },
    // 重新申请
    resetInfo() {
      debounce(() => {
        this.isActive = 1;
      }, 500);
    },
    // 查看协议
    showAgreement() {
      const url =
        'https://wuzhuang-buket02.oss-cn-beijing.aliyuncs.com/userFile/userFile/%E3%80%8A%E7%94%B5%E5%AD%90%E5%8F%91%E7%A5%A8%E6%9C%8D%E5%8A%A1%E5%BC%80%E9%80%9A%E8%A7%84%E5%88%99%E3%80%8B-%20%E7%BB%88%E7%89%880.2.pdf';
      window.open(url);
    },
    // 判断是不是集成供应商
    async companyWhetherSystemIntegration() {
      const info = await invoiceApi.companyWhetherSystemIntegration();
      if (info.success) {
        this.isCompanyWhetherSystemIntegration = info.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin/flex.scss';
.invoive-serve {
  background: #fff;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  .explain {
    padding: 11px 10px;
    background: #f4f7ff;
    font-size: 14px;
    font-style: normal;
    font-weight: 350;
    line-height: 24px;
    color: #666;
    margin-top: 20px;
  }
  .waring {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 20px;

    font-size: 14px;
    font-style: normal;
    font-weight: 350;
    .waring-icon {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }
  .commodity-list {
    .invoice-form {
      margin-top: 20px;
      ::v-deep .el-form-item__label {
        color: #333;
        font-size: 14px;
        font-style: normal;
        font-weight: 350;
        line-height: 30px;
      }
      ::v-deep .el-form-item--small.el-form-item {
        margin-bottom: 20px;
      }
    }
  }
  .agreement {
    font-size: 14px;
    font-style: normal;
    font-weight: 350;
    line-height: 14px;
    .check-box {
      margin-right: 10px;
    }
    .show-agreement {
      cursor: pointer;
      color: #2587ff;
    }
  }
  .button {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    .submit-btn {
      width: 81px;
      height: 30px;
      line-height: 40px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
  .warn {
    display: flex;
    justify-content: start;
    background: rgba(299, 1, 19, 0.06);
    padding: 20px;
    .warn-icon {
      width: 18px;
      height: 18px;
      margin-right: 10px;
    }
    .warn-text {
      font-size: 14px;
      font-style: normal;
      font-weight: 350;
      color: #333;
      line-height: 20px;
      position: relative;
      top: -2px;
    }
  }
  .reset-button {
    margin-top: 20px;
    text-align: center;
  }
  .invoive-serve-success {
    text-align: center;
    .text {
      font-size: 14px;
      font-style: normal;
      font-weight: 350;
      color: #666;
    }
    .config-text {
      font-size: 14px;
      font-style: normal;
      font-weight: 350;
      color: #333;
      margin-top: 20px;
    }
    .text-btn {
      font-size: 14px;
      font-style: normal;
      font-weight: 350;
      line-height: 14px; /* 100% */
      text-decoration-line: underline;
      color: #2587ff;
      cursor: pointer;
    }
    .invoice-manerge {
      margin-top: 30px;
    }
  }
}
</style>
